var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path3, _path4, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 954,
    height: 116,
    viewBox: "0 0 954 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.9606 77.5942L109.449 76.7774L57.1747 24.5034H176.425V0H0L75.9606 77.5942Z",
    fill: "#020202"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.868 37.5718L96.38 38.3886L148.654 90.6626L29.404 90.6626L29.404 115.166L205.829 115.166L129.868 37.5718Z",
    fill: "#9DF026"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 217.264,
    y: 23.2773,
    width: 81.6781,
    height: 13.0685,
    fill: "#020202"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 217.264,
    y: 51.0469,
    width: 81.6781,
    height: 13.0685,
    fill: "#020202"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 217.264,
    y: 78.8184,
    width: 81.6781,
    height: 13.0685,
    fill: "#020202"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 230.332,
    y: 34.7129,
    width: 24.5034,
    height: 13.0685,
    transform: "rotate(90 230.332 34.7129)",
    fill: "#020202"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 298.941,
    y: 62.4824,
    width: 29.4041,
    height: 13.0685,
    transform: "rotate(90 298.941 62.4824)",
    fill: "#020202"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 303.842,
    y: 78.8184,
    width: 98.0137,
    height: 13.0685,
    fill: "#020202"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 401.856,
    y: 23.2773,
    width: 68.6096,
    height: 13.0685,
    transform: "rotate(90 401.856 23.2773)",
    fill: "#020202"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 359.383,
    y: 23.2773,
    width: 68.6096,
    height: 13.0685,
    transform: "rotate(90 359.383 23.2773)",
    fill: "#020202"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 316.911,
    y: 23.2773,
    width: 68.6096,
    height: 13.0685,
    transform: "rotate(90 316.911 23.2773)",
    fill: "#020202"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 419.825,
    y: 65.75,
    width: 45.7397,
    height: 13.0685,
    fill: "#020202"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M452.496 23.2773L481.9 91.8869L468.832 91.8869L439.428 23.2773L452.496 23.2773Z",
    fill: "#020202"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M447.596 23.2773L419.825 91.8869L406.757 91.8869L434.527 23.2773L447.596 23.2773Z",
    fill: "#020202"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 486.801,
    y: 23.2773,
    width: 81.6781,
    height: 13.0685,
    fill: "#020202"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 486.801,
    y: 60.8496,
    width: 81.6781,
    height: 13.0685,
    fill: "#020202"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 568.479,
    y: 34.7129,
    width: 37.5719,
    height: 13.0685,
    transform: "rotate(90 568.479 34.7129)",
    fill: "#020202"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 499.87,
    y: 62.4824,
    width: 29.4041,
    height: 13.0685,
    transform: "rotate(90 499.87 62.4824)",
    fill: "#020202"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 596.25,
    y: 23.2773,
    width: 86.5788,
    height: 16.3356,
    fill: "#020202"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 596.25,
    y: 49.4141,
    width: 86.5788,
    height: 16.3356,
    fill: "#020202"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 596.25,
    y: 75.5508,
    width: 86.5788,
    height: 16.3356,
    fill: "#020202"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 612.586,
    y: 34.7129,
    width: 24.5034,
    height: 16.3356,
    transform: "rotate(90 612.586 34.7129)",
    fill: "#020202"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 682.829,
    y: 62.4824,
    width: 29.4041,
    height: 16.3356,
    transform: "rotate(90 682.829 62.4824)",
    fill: "#020202"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 687.73,
    y: 23.2773,
    width: 84.9452,
    height: 16.3356,
    fill: "#020202"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 738.371,
    y: 24.9121,
    width: 66.976,
    height: 16.3356,
    transform: "rotate(90 738.371 24.9121)",
    fill: "#020202"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 777.576,
    y: 23.2773,
    width: 84.9452,
    height: 16.3356,
    fill: "#020202"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 777.576,
    y: 75.5508,
    width: 84.9452,
    height: 16.3356,
    fill: "#020202"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 793.912,
    y: 24.9121,
    width: 66.976,
    height: 16.3356,
    transform: "rotate(90 793.912 24.9121)",
    fill: "#020202"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 862.521,
    y: 24.9121,
    width: 66.976,
    height: 16.3356,
    transform: "rotate(90 862.521 24.9121)",
    fill: "#020202"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 867.422,
    y: 23.2773,
    width: 86.5788,
    height: 16.3356,
    fill: "#020202"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 867.422,
    y: 57.582,
    width: 86.5788,
    height: 16.3356,
    fill: "#020202"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 954.001,
    y: 34.7129,
    width: 37.5719,
    height: 16.3356,
    transform: "rotate(90 954.001 34.7129)",
    fill: "#020202"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 883.758,
    y: 62.4824,
    width: 29.4041,
    height: 16.3356,
    transform: "rotate(90 883.758 62.4824)",
    fill: "#020202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logo-full.a95783f5d2b30e367a94e48e41ab966a.svg";
export { ForwardRef as ReactComponent };